/*eslint-disable*/
import React from "react";
import { Link } from "react-router-dom";
// components
import { sponsors } from "../../assets/sponsored_content/sponsors.js";

export default function BottomBar(props) {
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  return (
    <>
      <nav className="bottom-0 fixed z-50 w-full flex flex-wrap items-center justify-between px-2 py-3 navbar-expand-lg bg-white opacity-90 shadow">
        <div className="container px-4 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <Link
              to="/"
              className="text-warmGray-800 text-sm font-bold leading-relaxed inline-block mr-4 py-2 whitespace-nowrap "
            >
              Mūs atbalstīja
            </Link>
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              <i className={`fas ${navbarOpen ? "fa-times" : "fa-expand-alt"} `}></i>
            </button>
          </div>
          <div
            className={
              "lg:flex flex-grow items-center bg-white lg:bg-opacity-0 lg:shadow-none" +
              (navbarOpen ? " block" : " hidden")
            }
            id="example-navbar-warning"
          >

            <ul className="flex flex-wrap lg:flex-row list-none lg:ml-auto ">
              {["platinum", "gold", "silver", "bronze", "promo"].map((tier, tierIndex) => {
                const tierSponsors = sponsors[tier];
                if (!tierSponsors || tierSponsors.length === 0) return null;

                return (
                  <React.Fragment key={tier}>
                    {/* Divider between tiers (only after the first) */}
                    {tierIndex > 0 && (
                      <div
                        className="bg-lsfm-primary-800 mx-4 hidden lg:block"
                        style={{ width: 2 }}
                      ></div>
                    )}

                    {/* Sponsors in this tier */}
                    {tierSponsors.map((sponsor, index) => (
                      <li key={`${tier}-${index}`} className="flex  items-center">
                        <a
                          className="hover:opacity-80 text-blueGray-700 px-3 py-2 lg:py-2 flex flex-col items-center justify-between h-full text-xs  font-base"
                          href={sponsor.link !== "" && sponsor.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img
                            src={sponsor.logo}
                            alt={sponsor.name}
                            className="object-contain transition-transform duration-300"
                            style={{ maxHeight: "36px", maxWidth: "120px" }}
                          />
                          <span className="inline-block ml-2 mt-2">{sponsor.name}</span>
                        </a>
                      </li>
                    ))}
                  </React.Fragment>
                );
              })}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}
